<template>
  <FileThumbnail class="thumbnail" :thumbnail-url="thumbnailUrl" :is-loading="isLoading">
    <IconButton
      class="remove-button"
      v-if="isRemovable"
      variant="secondary"
      size="small"
      shape="square"
      icon="trash"
      @click="remove"
    />
  </FileThumbnail>
</template>

<script setup lang="ts">
import { IconButton } from '@tallo/design-system';

import FileThumbnail from './file-thumbnail.vue';

defineProps<{
  isLoading?: boolean;
  thumbnailUrl?: string | null;
  isRemovable?: boolean;
}>();

const emit = defineEmits<{ remove: [] }>();

function remove(event: Event) {
  event.stopPropagation();
  emit('remove');
}
</script>

<style scoped lang="scss">
.thumbnail:hover {
  .remove-button {
    opacity: 1;
  }
}

.remove-button {
  position: absolute;
  top: var(--t-spacing-sm);
  right: var(--t-spacing-sm);
  opacity: 0;
  transition: 300ms ease-in-out;

  @media (hover: none) {
    opacity: 1;
  }
}
</style>
